<template>
  <el-tabs class="tab" v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane :label="item.name" :name="item.id" v-for="item in tabs" :key="item.id">
      <slot></slot>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: [],
    },
    activeName: {
      type: String,
      default: '1',
    },
  },
  methods: {
    handleClick(tab, event) {
      this.$emit("chooseTopic", tab.name);
    },
  },
  created() { },
};
</script>

<style>
.tab .el-tabs--card>.el-tabs__header .el-tabs__nav {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.tab .el-tabs__item {
  padding: 14px 25px;
  border-radius: 50px;
  border: solid 1px #E5E5EA !important;
  background-color: #fff;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #2C2C2E;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  height: auto;
  margin-right: 8px;
}

.tab .el-tabs__item:hover {
  background-color: #E2291E;
  color: #fff;
}

.tab .el-tabs__item.is-active {
  background-color: #E2291E;
  color: #fff;
}

.tab .el-tabs--card>.el-tabs__header {
  border-bottom: none;
}
.el-tabs--card>.el-tabs__header{
  border-bottom: none;
}
@media (max-width: 768px) {
  .tab .el-tabs__item {
    padding: 9px 22px;
    font-size: 14px;
  }
  .tab .el-tabs__item.is-active{
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/tabs.vue